// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1117":"c72d795a","1437":"d28d7108","4273":"1f92a9ec","6547":"a256da5a","7712":"7459ce6e","9706":"3aaf4b37","9826":"4890d95a"}[chunkId] + ".chunk.css";
};